import { useTranslation } from 'next-i18next';
import { useEffect, useRef } from 'react';

const GameLicense = () => {
    const { t } = useTranslation();
    const sealRef = useRef(null);
    const scriptLoaded = useRef(false);


    useEffect(() => {
        const script1 = document.createElement('script');
        script1.src = 'https://913b555d-5bd3-4dbf-ac70-bfee5507839e.seals.dlagglobal.com/dlag-seal.js';
        script1.async = true;
        document.body.appendChild(script1);
        script1.onload = () => {
            scriptLoaded.current = true;
        };
        return () => {
            document.body.removeChild(script1);
        };
    }, []);

    useEffect(() => {
        if (scriptLoaded.current && sealRef.current && window.dlag_913b555d_5bd3_4dbf_ac70_bfee5507839e) {
            window.dlag_913b555d_5bd3_4dbf_ac70_bfee5507839e.init();
        }
    }, [sealRef.current, scriptLoaded.current]);

    return (
        <div className="footer__col footer__col--gaming-lic">
            <div className="footer__heading">
                <i className="icon icon--certified" />
                <span className="text">{t('lbl_GamingLic')}</span>
            </div>
            <div className="footer__item">
                <div ref={sealRef} id="dlag-913b555d-5bd3-4dbf-ac70-bfee5507839e" data-dlag-seal-id="913b555d-5bd3-4dbf-ac70-bfee5507839e" data-dlag-image-size="128" data-dlag-image-type="basic-small"></div>
            </div>
        </div>
    );
};

export default GameLicense;
